"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var material_1 = require("@mui/material");
var approvals_helper_1 = require("../approvals_helper");
var details_field_1 = require("./details_field");
var ReferenceNumbersApprovalView = function (_a) {
    var previousData = _a.previousData, updatedData = _a.updatedData, isUpdatedData = _a.isUpdatedData;
    return (React.createElement("div", { className: "visit-details" },
        React.createElement(material_1.Grid, { container: true, spacing: 2, columns: 12, className: "details-profile-grid" },
            React.createElement(material_1.Grid, { item: true, xs: isUpdatedData
                    ? 6
                    : 12, container: true },
                isUpdatedData && (React.createElement(material_1.Grid, { className: "tab-heading-wrapper", item: true, xs: 12 },
                    React.createElement("div", { className: "tab-heaidng profile-detail-heaidng" },
                        React.createElement("h2", null, "Previous Data")))),
                React.createElement(material_1.Grid, { item: true, xs: 12, container: true, className: "mini-details-wrapper" }, previousData &&
                    Object.entries(approvals_helper_1.approvalsFormConstants.reference_numbers)
                        .filter(function (_a) {
                        var key = _a[0];
                        return key in previousData;
                    })
                        .map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return (React.createElement(details_field_1.default, { key: key, fieldKey: key, lableName: value.label, value: previousData[key], isEditable: isUpdatedData ? false : value.editable, fieldType: value.type, showEmpty: true }));
                    }))),
            updatedData &&
                updatedData &&
                isUpdatedData && (React.createElement(material_1.Grid, { item: true, xs: 6, container: true },
                React.createElement(material_1.Grid, { className: "tab-heading-wrapper", item: true, xs: 12 },
                    React.createElement("div", { className: "tab-heaidng profile-detail-heaidng" },
                        React.createElement("h2", null, "Updated Data"))),
                React.createElement(material_1.Grid, { item: true, xs: 12, container: true, className: "mini-details-wrapper" }, updatedData &&
                    Object.entries(approvals_helper_1.approvalsFormConstants.reference_numbers)
                        .filter(function (_a) {
                        var key = _a[0];
                        return key in updatedData;
                    })
                        .map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return (React.createElement(details_field_1.default, { key: key, fieldKey: key, lableName: value.label, value: updatedData[key], isEditable: isUpdatedData ? value.editable : false, fieldType: value.type, showEmpty: false }));
                    })))))));
};
exports.default = ReferenceNumbersApprovalView;
